import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const deleteRole = (resource, id, { lotId, roleId }) => {
  return axios.delete(`/api/${resource}/${id}/setup/lots/${lotId}/roles/${roleId}`);
};

export const useDeleteRole = (resource, id, onSuccess) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (values) => deleteRole(resource, id, values),
    onSuccess: () => {
      enqueueSnackbar('Role successfully deleted', { variant: 'success' });
      onSuccess();
    },
    onError: (error) => {
      enqueueSnackbar(error?.response?.data?.description || error?.message || 'Some error occured', {
        variant: 'error',
      });
    },
  });
};
